import toggle from '../helpers/toggleArrayElement';

const FULL_TEXT_SEARCH_CHANGED = 'FULL_TEXT_SEARCH_CHANGED';
const COUNTRY_TOGGLED = 'COUNTRY_TOGGLED';
const REGION_TOGGLED = 'REGION_TOGGLED';
const CITY_TOGGLED = 'CITY_TOGGLED';
export const FILTERS_CLEARED = 'FILTERS_CLEARED';
const DISTRIBUTION_IN_COUNTRIES_TOGGLED = 'DISTRIBUTION_IN_COUNTRIES_TOGGLED';
const DISTRIBUTION_SOUGHT_COUNTRIES_TOGGLED =
  'DISTRIBUTION_SOUGHT_COUNTRIES_TOGGLED';
const EVENT_TOGGLED = 'EVENT_TOGGLED';
const OFFERING_TOGGLED = 'OFFERING_TOGGLED';
const OPENING_HOURS_TOGGLED = 'OPENING_HOURS_TOGGLED';
const WINE_EXPERIENCE_TOGGLED = 'WINE_EXPERIENCE_TOGGLED';
const LIFESTYLE_TOGGLED = 'LIFESTYLE_TOGGLED';
const HOSPITALITY_TOGGLED = 'HOSPITALITY_TOGGLED';
const OUTDOOR_EXPERIENCE_TOGGLED = 'OUTDOOR_EXPERIENCE_TOGGLED';

export function offeringToggled(value) {
  return [OFFERING_TOGGLED, value];
}

export function eventToggled(value) {
  return [EVENT_TOGGLED, value];
}

/**
 *
 * @param {string} queryString The term to search.
 * @returns {[typeof FULL_TEXT_SEARCH_CHANGED, string]}
 */
export function searchTermChanged(queryString) {
  return [FULL_TEXT_SEARCH_CHANGED, queryString];
}

export function countryToggled(vintage) {
  return [COUNTRY_TOGGLED, vintage];
}

export function regionToggled(variety) {
  return [REGION_TOGGLED, variety];
}

export function cityToggled(vintage) {
  return [CITY_TOGGLED, vintage];
}

export function distributionInCountriesToggled(vintage) {
  return [DISTRIBUTION_IN_COUNTRIES_TOGGLED, vintage];
}

export function distributionSoughtCountriesToggled(vintage) {
  return [DISTRIBUTION_SOUGHT_COUNTRIES_TOGGLED, vintage];
}

export function openingHoursToggled(vintage) {
  return [OPENING_HOURS_TOGGLED, vintage];
}

export function wineExperienceOfferingsToggled(value) {
  return [WINE_EXPERIENCE_TOGGLED, value];
}
export function hospitalityOfferingsToggled(value) {
  return [HOSPITALITY_TOGGLED, value];
}
export function lifestyleOfferingsToggled(value) {
  return [LIFESTYLE_TOGGLED, value];
}
export function outdoorExperienceOfferingsToggled(value) {
  return [OUTDOOR_EXPERIENCE_TOGGLED, value];
}

export function filtersCleared() {
  return [FILTERS_CLEARED];
}

const initialFilterState = {
  searchTerm: '',
  events: [],
  countries: [],
  regions: [],
  cities: [],
  distributionInCountries: [],
  distributionSoughtCountries: [],
  offerings: [],
  openingHours: [],
  wineExperienceOfferings: [],
  hospitalityOfferings: [],
  lifestyleOfferings: [],
  outdoorExperienceOfferings: [],
};

// The complete state could be different, e.g. have the sort order or grouping in it.
export const initialState = { ...initialFilterState };

export default function reducer(state, event) {
  const [type, payload] = event;
  switch (type) {
    case FULL_TEXT_SEARCH_CHANGED: {
      return { ...state, searchTerm: payload };
    }

    case EVENT_TOGGLED: {
      return {
        ...state,
        events: toggle(state.events, payload),
      };
    }

    case OFFERING_TOGGLED: {
      return {
        ...state,
        offerings: toggle(state.offerings, payload),
      };
    }

    case COUNTRY_TOGGLED: {
      return {
        ...state,
        countries: toggle(state.countries, payload),
        currentOffset: 0,
      };
    }

    case CITY_TOGGLED: {
      return {
        ...state,
        cities: toggle(state.cities, payload),
        currentOffset: 0,
      };
    }

    case REGION_TOGGLED: {
      return {
        ...state,
        regions: toggle(state.regions, payload),
        currentOffset: 0,
      };
    }

    case DISTRIBUTION_IN_COUNTRIES_TOGGLED: {
      return {
        ...state,
        distributionInCountries: toggle(state.distributionInCountries, payload),
        currentOffset: 0,
      };
    }
    case DISTRIBUTION_SOUGHT_COUNTRIES_TOGGLED: {
      return {
        ...state,
        distributionSoughtCountries: toggle(
          state.distributionSoughtCountries,
          payload
        ),
        currentOffset: 0,
      };
    }

    case OPENING_HOURS_TOGGLED: {
      return {
        ...state,
        openingHours: toggle(state.openingHours, payload),
        currentOffset: 0,
      };
    }

    case WINE_EXPERIENCE_TOGGLED: {
      return {
        ...state,
        wineExperienceOfferings: toggle(state.wineExperienceOfferings, payload),
        currentOffset: 0,
      };
    }

    case HOSPITALITY_TOGGLED: {
      return {
        ...state,
        hospitalityOfferings: toggle(state.hospitalityOfferings, payload),
        currentOffset: 0,
      };
    }

    case LIFESTYLE_TOGGLED: {
      return {
        ...state,
        lifestyleOfferings: toggle(state.lifestyleOfferings, payload),
        currentOffset: 0,
      };
    }

    case OUTDOOR_EXPERIENCE_TOGGLED: {
      return {
        ...state,
        outdoorExperienceOfferings: toggle(
          state.outdoorExperienceOfferings,
          payload
        ),
        currentOffset: 0,
      };
    }

    case FILTERS_CLEARED: {
      return {
        ...state,
        ...initialFilterState,
      };
    }

    default:
      return state;
  }
}
